import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';
import Dropdown from '../Dropdown/Dropdown';
import { Tag } from './Styled';
import { ToolTipSmall } from '../common/TooltipLabel/styled';
import Tooltips from '../../config/Tooltips';

class DropdownTags extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: this.props.options,
            selectedOption: this.props.selected,
            selectedList: this.props.selectedList,
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.selectedList) {
            let selectedItems = nextProps.selectedList.map(item => item.name);

            this.setState({
                options: nextProps.options.filter(option => !selectedItems.includes(option.name))
            });
        }
    }

    /**
     * handleChange
     * string - selectedOption
     * Altering the array of selectedList by populating it with selectedOption
     * Set state of selectedList
     */
    handleChange = (selected) => {
        this.props.handleChange(selected);
    }
    /**
     * deleteChange
     * integer - selectedListItemIndex
     * Using index of item to remove from selectedList
     * Set state of selectedList
     */
    deleteChange = (selected, selectedListItemIndex) => {
        this.props.deleteChange(selected, selectedListItemIndex);
    }

    render() {
        const selectedList = this.props.selectedList;
        const tagList = selectedList ?
            selectedList.map((selectedItem, index) => {
                return (
                    <Tag
                        role="button"
                        id={`tag-item-${index}`}
                        onClick={() => {
                            this.deleteChange(selectedItem, index);
                        }}
                        key={index}>
                        {selectedItem.name}<i className="fa fa-times" aria-hidden="true"></i>
                    </Tag>)
            }) : [];
        return (
                <Row className="pb-3 pl-3 pr-3">
                    <Col className="pl-0" xs="3">
                    <Dropdown
                            id={this.props.id}
                            handleChange={this.handleChange}
                            title={this.props.title}
                            selected={this.props.selected}
                            options={this.state.options} 
                            tags={true}/>
                    </Col>
                    <Col xs="0" className="pt-3 pl-0">
                        <ToolTipSmall className="pl-0" id="attribute-tooltip" placement="right" item={Tooltips.attributeDescription} colSize="12" />
                    </Col>
                    <Col className="pl-0 pt-1" xs="8">
                        {tagList}
                    </Col>
                    
                </Row>
        );
    }
}

DropdownTags.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    selected: PropTypes.string,
    options: PropTypes.array,
}

export default DropdownTags;




// WEBPACK FOOTER //
// ./src/components/DropdownTags/DropdownTags.js